import { Suspense } from 'react'
import { useRoutes } from 'react-router'
import { protectedRoutes } from './protected'
import { publicRoutes } from './public'

export function AppRouter() {

  const routes = useRoutes([
    ...publicRoutes,
    ...protectedRoutes,
    {
      path: '*',
      element: <div> Not Found </div>,
    },
  ])

  return (
    <Suspense fallback={(
      <div> Loading... </div>
    )}
    >
      { routes }
    </Suspense>
  )
}
